import React, {useState, useEffect} from 'react';
import { SafeAreaView } from 'react-native-safe-area-context';
import { Button, Divider, Layout, Text, Icon, Input, Select, SelectItem,IndexPath, Avatar } from '@ui-kitten/components';
import { StyleSheet, ScrollView, Dimensions, Image } from 'react-native';
import * as ImagePicker from 'expo-image-picker';
import trackerApi from '../../../api/tracker';
import { showMessage, hideMessage } from "react-native-flash-message";
import * as RootNavigation from '../../../../root.navigation.js';
import { useSelector} from 'react-redux';

const width = Dimensions.get('window').width;



const CameraIcon = (props) => (
  <Icon {...props} name='camera' />
);


const FileIcon = (props) => (
  <Icon {...props} name='folder' />
);

const ImageIcon = (props) => (
  <Icon {...props} name='image' fill='#417CBE' style={{width:60, height:60, marginTop:30, marginBottom:10}} />
);

const CheckIcon = (props) => (
  <Icon {...props} name='checkmark-circle'  fill='#A0D308' style={{width:60, height:60, marginTop:30, marginBottom:10}}/>
);

const TelIcon = (props) => (
  <Icon {...props} name='phone' />
);

const AddressIcon = (props) => (
  <Icon {...props} name='compass-outline' />
);

const service = [
  'در بازکن صوتی تصویری',
  'در باز کن کنترلی'
]

export const UploadPictures = ({ navigation }) => {
  const [image, setImage] = useState(null);
  const [profileUri, setProfileUri] = useState(null);
  const [cardUri,setCardUri] = useState(null);
  const [profileSelected, setProfileSelected] = useState(false);
  const [cardSelected,setCardSelected] = useState(false);

  const phone = useSelector( state => state.login.phoneNumber);

  // const [status, requestPermission] = ImagePicker.requestCameraPermissionsAsync();
  // const [status, requestPermission] = ImagePicker.useMediaLibraryPermissions();

  useEffect(() => {
    (async () => {
        if (Platform.OS !== 'web') {
          const { status1 } = await ImagePicker.requestMediaLibraryPermissionsAsync();
          // const { status2 } = await ImagePicker.requestCameraPermissionsAsync();
          // const [status, requestPermission] = await ImagePicker.requestCameraRollPermissionsAsync();
          // const [status, requestPermission] = ImagePicker.useCameraPermissions();

          // const { status2 } = await ImagePicker.requestCameraPermissionsAsync();

          if (status1 !== 'granted') {
            console.log('Sorry, we need camera roll permissions to make this work!');
          }
        }

      })();
  }, []);

  const uploadProfile = async (imageUri)=>{
    let formdata = new FormData();
    await formdata.append('file',{
        uri: Platform.OS === 'android' ? imageUri : 'file://' + imageUri,
        name: phone.toString(),
        type: 'image/jpg' // or your mime type what you want
    });

    const response = await trackerApi.post('/imagePicker', formdata, {   headers: { "Content-Type": "multipart/form-data" }})
    // console.log(response.data);
    if(response.status == 500){
      return showMessage({
        message: response.data,
        type: "warning",
      });
    }
    else {
    showMessage({
      message: 'با موفقیت بارگذاری شد',
      type: "success",
    });
    setProfileSelected(true)
  }
    // readData();
  }

  const uploadCard = async (imageUri)=>{
    let formdata = new FormData();
    await formdata.append('file',{
        uri: Platform.OS === 'android' ? imageUri : 'file://' + imageUri,
        name: phone.toString(),
        type: 'image/jpg' // or your mime type what you want
    });

    const response = await trackerApi.post('/cardImagePicker', formdata, {   headers: { "Content-Type": "multipart/form-data" }})
    // console.log(response.data);
    if(response.status == 500){
      return showMessage({
        message: response.data,
        type: "warning",
      });
    }
    else{
      showMessage({
        message: 'با موفقیت بارگذاری شد',
        type: "success",
      });
      setCardSelected(true)
    }

    // readData();
  }

  const pickProfileImage = async () => {
      let result = await ImagePicker.launchImageLibraryAsync({
        mediaTypes: ImagePicker.MediaTypeOptions.Images,
        allowsEditing: true,
        aspect: [1, 1],
        quality: 0.4,
      });
      if (!result.cancelled) {
      setProfileUri(result.assets[0].uri);
      // console.log(result.uri);
      uploadProfile(result.assets[0].uri);
    }
}

const pickCardImage = async () => {
    let result = await ImagePicker.launchImageLibraryAsync({
      mediaTypes: ImagePicker.MediaTypeOptions.Images,
      allowsEditing: true,
      aspect: [4, 3],
      quality: 0.4,
    });
    if (!result.cancelled) {
    setCardUri(result.assets[0].uri);
    uploadCard(result.assets[0].uri);

  }
}

const takeProfileImage = async () => {
      let result = await ImagePicker.launchCameraAsync({
        mediaTypes: ImagePicker.MediaTypeOptions.Images,
        allowsEditing: true,
        aspect: [1, 1],
        quality: 0.4,
        base64: true
      });

      // console.log(result);

      if (!result.cancelled) {
        setProfileUri(result.assets[0].uri);
        uploadProfile(result.assets[0].uri);

      }
    };

    const takeCardImage = async () => {
          let result = await ImagePicker.launchCameraAsync({
            mediaTypes: ImagePicker.MediaTypeOptions.Images,
            allowsEditing: true,
            aspect: [4, 3],
            quality: 0.4,
            base64: true
          });

          // console.log(result);

          if (!result.cancelled) {
            setCardUri(result.assets[0].uri);
            uploadCard(result.assets[0].uri);

          }
        };

  return (

      <Layout style={styles.container} level='3' >
      <SafeAreaView>
      <ScrollView>
      <Layout level='3' style={{flex:1,justifyContent:'flex-start', alignItems:'center', width:width-50, marginHorizontal:15}}>
        <Image
          style={{width:width*0.4, height: width*0.4/1.43, marginVertical:10}}
          source={require('../../../../assets/form.png')} />
        <Text category='h5' status='primary'>بارگذاری مدارک</Text>
        <Layout level='3' style={{alignItems:'center'}}>
          <Text category='h6' status='primary'>عکس پروفایل</Text>

          <Avatar
            style={{width:128,height:128, marginBottom:10, marginTop:20, borderWidth:3, borderColor:'#417CBE'}}
            source={profileUri ? {uri: profileUri} :  require('../../../../assets/14.jpg')}
            size='giant'
            />
          <Layout level='3' style={{flexDirection:'row', justifyContent:'space-between', width:width-60}}>
            <Button size='small' onPress={pickProfileImage} style={{flex:1, marginHorizontal:10}} appearance='outline' accessoryLeft={FileIcon} onPress={()=> {pickProfileImage()}}>گالری </Button>
            <Button size='small' onPress={takeProfileImage} style={{flex:1, marginHorizontal:10}} appearance='outline' accessoryLeft={CameraIcon} onPress={()=> {takeProfileImage()}}> دوربین </Button>
          </Layout>
        </Layout>

        <Layout level='3' style={{alignItems:'center', marginTop:20}}>

        <Text category='h6' status='primary'>تصویر کارت ملی</Text>

        { !cardUri &&
        <ImageIcon />
        }

        { cardUri &&
          <Image
            style={{width: width*2/3, height:width/2, maxHeight: 200,marginBottom:10, marginTop:20, borderWidth:3, borderColor:'#417CBE'}}
            source={{uri: cardUri}}
            />
          }
          <Layout level='3' style={{flexDirection:'row', justifyContent:'space-between', width:width-60}}>
            <Button size='small' onPress={pickCardImage} style={{flex:1, marginHorizontal:10}} appearance='outline' accessoryLeft={FileIcon} onPress={()=> {pickCardImage()}}>گالری </Button>
            <Button size='small' onPress={takeCardImage} style={{flex:1, marginHorizontal:10}} appearance='outline' accessoryLeft={CameraIcon} onPress={()=> {takeCardImage()}}> دوربین </Button>
          </Layout>
        </Layout>



          <Button style={{width:width-60,borderRadius:10, marginVertical:30}}
          disabled = {!(profileSelected&&cardSelected)}
          onPress={()=>{
            showMessage({
              message: 'ثبت نام با موفقیت انجام شد. ',
              description: 'پس از بررسی اطلاعات با شما تماس گرفته خواهد شد.',
              type: "success",
              duration: 5000
            });
            RootNavigation.navigate('Login')
          }}
          >ارسال</Button>

      </Layout>
      </ScrollView>
      </SafeAreaView>


      </Layout>
  );
};

const styles = StyleSheet.create({
  container:{
    flex:1,
    alignItems:'center',
    justifyContent:'space-between'
  },
});
